import { BtnTooltipType } from '../../shared/types/btn-tooltip.type';
import { FormConfigBase } from './abstract/form-config-base.class';
import { BtnTooltipInterface } from '../interfaces/btn-tooltip.interface';

export class BtnTooltipModel {
  label?: string;
  title?: string;
  placement?: BtnTooltipType;

  constructor( obj?: BtnTooltipInterface ) {

    this.label = obj && obj.label ? obj.label : '';
    this.title = obj && obj.title ? obj.title : '';
    this.placement = obj && obj.placement ? obj.placement : 'top';
  }

}
